// Weather helpers (data from Open-Meteo via the server's /api/weather).

export interface HourForecast {
  time: number;
  tempC: number;
  rainChance: number;
  code: number;
  windKph: number;
}

export interface Forecast {
  hours: HourForecast[];
  fetchedAt: number;
}

/** Glasgow city centre — used until the household sets its own location. */
export const DEFAULT_HOME = { lat: 55.8591, lon: -4.2451 };

export function describeCode(code: number): string {
  if (code === 0) return 'Clear';
  if (code <= 2) return 'Partly cloudy';
  if (code === 3) return 'Cloudy';
  if (code <= 48) return 'Fog';
  if (code <= 57) return 'Drizzle';
  if (code <= 67) return 'Rain';
  if (code <= 77) return 'Snow';
  if (code <= 82) return 'Showers';
  if (code <= 86) return 'Snow showers';
  return 'Thunder';
}

/** Best (driest, mildest) hour to go out in the next `within` hours, daylight-ish only. */
export function bestWalkHour(f: Forecast, now: number, within = 8): HourForecast | undefined {
  const upcoming = f.hours.filter((h) => h.time >= now - 30 * 60_000 && h.time <= now + within * 3_600_000);
  const daylight = upcoming.filter((h) => {
    const hr = new Date(h.time).getHours();
    return hr >= 7 && hr <= 20;
  });
  const pool = daylight.length ? daylight : upcoming;
  return pool.reduce<HourForecast | undefined>((best, h) => {
    const score = h.rainChance + Math.max(0, h.windKph - 30) + (h.tempC > 24 ? (h.tempC - 24) * 10 : 0);
    const bestScore = best ? best.rainChance + Math.max(0, best.windKph - 30) + (best.tempC > 24 ? (best.tempC - 24) * 10 : 0) : Infinity;
    return score < bestScore ? h : best;
  }, undefined);
}
